export enum TabulationType {
  SDTM = 'SDTM',
  SDTMIG = 'SDTMIG',
  SENDIG = 'SENDIG',
};